import { PaperClipIcon } from "@heroicons/react/24/outline";

import { useCallback } from "react";

import { useTranslation } from "react-i18next";

import { ApiResponse } from "@/api/rest/core/types";
import { uploadDocuments } from "@/api/rest/services/documentService";
import { uploadFiles as uploadToStorage } from "@/api/rest/services/uploadService";
import UploadFilesPopup from "@/components/UploadFilesPopup.tsx";
import Button from "@/components/common/Button";

export default function UploadHouseholdFilesPopup({
  householdId,
  updateHousehold,
}: {
  householdId: number;
  updateHousehold: () => void;
}) {
  const { t } = useTranslation();
  const uploadFiles = useCallback(
    async (files: File[], onProgress: (fraction: number) => void): Promise<ApiResponse<boolean>> => {
      const uploads = await uploadToStorage(files, onProgress);
      return uploads.success ? await uploadDocuments(householdId, uploads.result) : uploads;
    },
    [householdId],
  );

  return (
    <UploadFilesPopup className="shrink-0" uploadCallback={uploadFiles} updateHousehold={updateHousehold}>
      <Button type="button" variant="outline">
        <PaperClipIcon className="w-4 h-4 mr-2" />
        {t("product.addProductFiles")}
      </Button>
    </UploadFilesPopup>
  );
}
